<template>
  <button
    class="AssetTableTrade btn btn-sm"
    :class="{ 'btn-success': !isMobile }"
    @click="
      $router.push(
        `/exchange/trade/${asset.exchId}/${asset.symbol}${
          asset.exchId === 2 ? '-' : ''
        }USDT`
      )
    "
  >
    <span v-if="!isMobile">{{ $t("exchange.trade") }}</span>
    <img v-else src="../static/trade-icon.svg" :alt="$t('exchange.trade')" />
  </button>
</template>

<script>
export default {
  name: "AssetTableTrade",
  props: {
    asset: Object,
    isMobile: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.AssetTableTrade {
  img {
    width: 24px;
    height: 24px;
    transform: rotate(-90deg);
  }
}
</style>
